import { DOM } from '../core/dom';
import { FreelancerSignup } from '../core/freelancer-signup';
import { FreelancersFAQ } from '../partials/freelancers_faq';
import { FreelancersPathToRemote } from '../partials/freelancers_path_to_remote';
import { FreelancerCallToAction } from '../partials/freelancer_call_to_action';
import { Intro } from '../partials/intro';
// import { RelatedCompanies } from '../partials/related_companies';

DOM.onReady(() => {
  FreelancersFAQ.onload();
  FreelancersPathToRemote.onload();
  FreelancerCallToAction.onload();
  // RelatedCompanies.onload();
  Intro.onload('freelancer', FreelancerSignup.display);
});